/* eslint-disable max-classes-per-file */
/* eslint-disable lines-between-class-members */
/* eslint-disable @typescript-eslint/no-inferrable-types */
export class ItemModel {
    name: string = '';
    router: string = 'Dash';
    icon: any = null;
    id: number = 0;
}
export class ErrosResponse {
  propertyName: string = '';
  errorMessage: string = '';
};
export class Response<T> {
  sucesso: boolean = false;
  dados: T | null = null;
  erros: ErrosResponse[] = [];
};
export class Token {
  token: string = '';
  expiresIn: number = 0;
};
export class LoginModel {
  email: string = '';
  senha: string = '';
};

export class AnexoUsuario {
    id: number = 0;
    copiaDocumento: string = '';
    copiaDocumentoFileName: string = '';
    fotoComDocumento: string = '';
    fotoComDocumentoFileName: string = '';
    usuarioId: string = '';
};

export class Usuario {
  usuarioId: string = '';
  nome: string = '';
  email: string = '';
  cpf: string = '';
  senha: string = '';
  confirmarSenha: boolean = false;
  confirmarEmail: 'Sim' | ' ' = ' ';
  confirmarDPO: 'Sim' | 'Reprovado' | ' ' = ' ';
  anexosUsuario: AnexoUsuario = new AnexoUsuario();
};
export class AnexoSolicitacao {
    id: number = 0;
    anexoFileName: string = '';
    solicitacaoId: string = '';
};
export class AcompanhamentoSolicitacao {
  id: number = 0;
  descricao: string = '';
  data: string = '';
  dataFormatada: string = '';
  flagViewResposta: string = '';
  solicitacaoId: string = '';
};

export class LinksUteis {
    linkWebSite: string = '';
    linkPoliticas: string = '';
    base64Logo: string = '';
}
export class Solicitacao {
  solicitacaoId: string = '';
  dataCriacao: string = '';
  descricao: string = '';
  status: 122270000 | 122270001 | 122270002 = 122270000;
  statusFormatado: 'Aberta' | 'Em Análise' | 'Encerrada' = 'Aberta';
  categoria: string = '';
  CPFUsuario: string = '';
  emailUsuario: string = '';
  nomeCategoria: string = '';
  acompanhamentoSolicitacoes: AcompanhamentoSolicitacao[] = [];
  anexoSolicitacoes: AnexoSolicitacao[] = [];
};

export class Categoria {
    categoriaSolicitacaoId: string = '';
    descricao: string = '';
};

export class RetornoLogin {
    dadosUsuario: Usuario = new Usuario();
    dadosToken: Token = new Token();
};

export class LoginResponse {
    dadosUsuario: Usuario = new Usuario();
    dadosToken: Token = new Token();
};

export function ValidarEmail(email: string): boolean {
  return /[\w, .]{3,}@[a-z, A-Z, 0-9, .]{3,}/g.test(email);
};

export class EmailContatoTermoConsentimento {
  email:string = '';
};

export class AlterarSolicitacaoRequest extends Solicitacao {
  deletarAnexos: string = '';
};
